import { Route } from '@angular/router';
import { gamesOnlineLeaveBusterGuard } from 'src/app/modules/games/guards/games-online-leave-buster.guard';

export const matchOnlineGameRoutes: Route[] = [
    {
        path: 'online-game/match',
        data: {
            hideTournamentNotification: true,
        },
        canDeactivate: [gamesOnlineLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/match-online-gameplay/match-online-gameplay.component').then(
                (c) => c.MatchOnlineGameplayComponent
            ),
    },
];

export const matchSpectateGameRoutes: Route[] = [
    {
        path: 'online-game/match/spectate/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/match-online-spectator/match-online-spectator.component').then(
                (c) => c.MatchOnlineSpecatorComponent
            ),
    },
];
